'use client'
import { setTheme, type ThemeClassName } from '@/actions/ui'
import { themeAtom } from '@/components/providers/atoms-provider'
import { useMediaQuery } from '@/hooks/use-media-query'
import { useAtomValue } from 'jotai'
import { useEffect, type JSX, type ReactNode } from 'react'

function ThemeManager({ children }: { children?: ReactNode }): JSX.Element {
    const theme = useAtomValue(themeAtom)
    const isSystemDark = useMediaQuery('(prefers-color-scheme: dark)')

    useEffect(() => {
        const updateTheme = async (): Promise<void> => {
            if (theme === 'light' || theme === 'dark') {
                let className: ThemeClassName
                switch (theme) {
                    case 'dark': {
                        className = 'dark'
                        break
                    }
                    case 'light': {
                        className = 'light'
                        break
                    }
                }
                await setTheme(theme, className)
            } else {
                const className: ThemeClassName = isSystemDark ? 'dark' : 'light'
                await setTheme('system', className)
            }
        }
        updateTheme()
    }, [theme, isSystemDark])

    return <>{children}</>
}

export { ThemeManager }
